// extracted by mini-css-extract-plugin
export default {"root":"NHGALQwu9qGwDqmy7rEs","scrolling":"rONoJliY7PQ1y2whW1bG"};